/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryBasicView } from './categoryBasicView';
import { CommunityBasic } from './communityBasic';
import { CommunityFocus } from './communityFocus';
import { CommunityPermissions } from './communityPermissions';
import { CommunityStatus } from './communityStatus';
import { LocationObject } from './locationObject';
import { UserBasic } from './userBasic';
import { UserRelationToGroup } from './userRelationToGroup';

export interface Community extends CommunityBasic { 
    permissions: CommunityPermissions;
    description: string;
    website?: string;
    linked_communities?: Array<CommunityBasic>;
}